import { DropdownMenu } from '../../../components/DropdownMenu'
import type { NavigationProps } from './types'

export function DesktopNavigation({
  items,
  openDropdowns,
  toggleDropdown,
}: NavigationProps) {
  return (
    <div className="hidden items-center sm:flex">
      <ul className="flex items-center space-x-4">
        {items.map((item) => (
          <li key={item.label} className={item.subItems ? 'relative' : ''}>
            {item.href ? (
              <a
                href={item.href}
                className="rounded px-3 py-2 text-white hover:bg-gray-700"
              >
                {item.label}
              </a>
            ) : item.onClick ? (
              <button
                type="button"
                onClick={item.onClick}
                className="rounded px-3 py-2 text-white hover:bg-gray-700"
              >
                {item.label}
              </button>
            ) : (
              <DropdownMenu
                item={item}
                isOpen={openDropdowns[item.label]}
                toggleDropdown={toggleDropdown}
              />
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
